import { render, staticRenderFns } from "./SetUpSection.vue?vue&type=template&id=7b512a64&scoped=true"
import script from "./SetUpSection.vue?vue&type=script&lang=ts"
export * from "./SetUpSection.vue?vue&type=script&lang=ts"
import style0 from "./SetUpSection.vue?vue&type=style&index=0&id=7b512a64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b512a64",
  null
  
)

export default component.exports